import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '../material.module';
import { AuthServiceService } from './auth/auth-service.service';
import { Config } from './config';
import { HttpClientModule } from '@angular/common/http';
import { TokenService } from './tokenManagement/token.service';
import { HttpheaderService } from './helpers/httpheader.service';


@NgModule({
  imports: [
    CommonModule,
    HttpClientModule,
    MaterialModule,
    
  ],
  declarations: [
    
  ],
  providers: [
    Config,
    HttpClientModule,
    AuthServiceService,
    HttpheaderService,
    TokenService
  ],
})
export class CoreModule { }
